<div class="login-modal">
    <div class="login-head">
        <div class="login-brand">
            <span class="login-mark">FDE</span>
            <span class="login-title">Financial Data Extractor</span>
        </div>
        <button aria-label="Close" class="login-close" type="button" (click)="cancel()">
            <i class="fa fa-times"></i>
        </button>
    </div>

    <div class="login-body">
        <div class="login-lead">
            <span class="login-lead-title">{{ sessionExpired ? 'Session expired' : 'Sign in' }}</span>
            <span class="login-lead-hint">
                {{ sessionExpired ? 'Your session has ended. Sign in to continue where you left off.' : 'Use your FDE credentials to continue.' }}
            </span>
        </div>

        <div class="login-error" *ngIf="authenticationError">
            <i class="fa fa-exclamation-circle"></i>
            <span>Wrong login or password. Check the credentials and try again.</span>
        </div>

        <form class="login-form" (ngSubmit)="login()">
            <div class="login-field">
                <label class="form-label" for="username">Login</label>
                <input type="text" class="form-control" name="username" id="username" autocomplete="username"
                       placeholder="your login" [(ngModel)]="username" #usernameInput>
            </div>

            <div class="login-field">
                <label class="form-label" for="password">Password</label>
                <div class="login-password">
                    <input [type]="passwordShown ? 'text' : 'password'" class="form-control" name="password" id="password"
                           autocomplete="current-password" placeholder="your password" [(ngModel)]="password">
                    <button type="button" class="login-eye" (click)="passwordShown = !passwordShown"
                            [title]="passwordShown ? 'Hide the password' : 'Show the password'">
                        <i class="fa" [ngClass]="passwordShown ? 'fa-eye-slash' : 'fa-eye'"></i>
                    </button>
                </div>
            </div>

            <div class="login-row">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="rememberMe" id="rememberMe"
                           [(ngModel)]="rememberMe">
                    <label class="form-check-label" for="rememberMe">Remember me</label>
                </div>
            </div>

            <button type="submit" class="btn btn-primary login-submit" [disabled]="signingIn || !username || !password">
                <i class="fa fa-spinner fa-spin" *ngIf="signingIn"></i>
                <span>{{ signingIn ? 'Signing in…' : 'Sign in' }}</span>
            </button>
        </form>
    </div>
</div>
